// extracted by mini-css-extract-plugin
export default {"list":"list_list__6IhMA","addItem":"list_addItem__pYehz","icon":"list_icon__GgVBy"};